import { render, staticRenderFns } from "./PzButton.vue?vue&type=template&id=26e3d26a&"
import script from "./PzButton.vue?vue&type=script&lang=js&"
export * from "./PzButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e3d26a')) {
      api.createRecord('26e3d26a', component.options)
    } else {
      api.reload('26e3d26a', component.options)
    }
    module.hot.accept("./PzButton.vue?vue&type=template&id=26e3d26a&", function () {
      api.rerender('26e3d26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Buttons/PzButton.vue"
export default component.exports